// Use lowercase names!
export enum FieldName {
    OrganisationId = 'organisation_id',
    OrganisationName = 'o_organisation',
    OrganisationDivisionName = 'o_divisionname',
    OrganisationTerritory = 'o_territory',
    OrganisationType = 'o_type',
    OrganisationStatus = 'o_status',
    OrganisationIndustry = 'o_industry',
    OrganisationAlert = 'o_alert',
    OrganisationOwner = 'o_owner',
    OrganisationOwner2 = 'o_owner2',
    OrganisationTelephone = 'o_telephone',
    OrganisationWww = 'o_www',
    OrganisationAddress = 'o_adr',
    OrganisationCity = 'o_city',
    OrganisationPostCode = 'o_postcode',
    OrganisationState = 'o_state',
    OrganisationCountry = 'o_country',
    OrganisationCurrency = 'o_currency',

    PersonId = 'person_id',
    PersonFirstName = 'p_firstname',
    PersonLastName = 'p_lastname',
    PersonMiddleName = 'p_middlename',
    PersonTitle = 'p_title',
    PersonEmail = 'p_email',
    PersonEmail2 = 'p_email2',
    PersonMobilePhone = 'p_mobiletel',
    PersonDirectPhone = 'p_dirtel',
    PersonOrganisationId = 'p_organisationid',

    ActivityDescription = 'a_description',
    ActivityAssignedTo = 'a_assignedTo',
    ActivityDateTime = 'a_date',
    ActivityPersonId = 'a_personid',
    ActivityAllDay = 'a_allday',
    ActivityAction = 'a_action',
    ActivityType = 'a_type',
    ActivityMainProductService = 'a_product',

    OpportunityDescription = 'op_description',
    OpportunityAssignedTo = 'op_assignedto',
    OpportunityAssignedTo2 = 'op_assignedto2',
    OpportunityPersonId = 'op_personid',
    OpportunityOrderDate = 'op_orderdate',
    OpportunityOrderValue = 'op_ordervalue',
    OpportunityLevel = 'op_level',
    OpportunityLevelText = 'op_leveltext',
    OpportunityPipelineType = 'op_pipelinetype',
    OpportunityCurrency = 'op_currency',
    OpportunityMainProductService = 'op_product',
    OpportunityNumber = 'op_number',

    DeliveryResponsible = 'opc_deliveryresponsible',
    DeliveryPersonId = 'opc_personid',
    DeliveryPhase = 'opc_deliveryphase',
    DeliveryCurrency = 'opc_currency',
    DeliveryNumber = 'opc_number',
    DeliveryStatus = 'opc_status',

    SupportCaseSubject = 's_subject',
    SupportCaseDeadline = 's_deadline',
    SupportCaseTicket = 's_ticket',
    SupportCasePersonId = 's_personid',
    SupportCaseAssignedTo = 's_assignedto',
    SupportCaseOwner = 's_ownerid',
    SupportCaseChannel = 's_channel',
    SupportCaseAction = 's_action',
    SupportCaseMainProductService = 's_product',

    UserCurrency = 'u_currency',
}